// src/config/routes.js

export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  DIGNITARIES: "/dignitaries",
  COMMITTEE: "/committee",
  SCHEDULE: "/schedule",
  REGISTRATION: "/registration",
  SPONSORSHIP: "/sponsorship",
  CONTACT: "/contact",
  GALLERY: "/gallery",

  CALL_ABSTRACT: "/call/abstract",
  CALL_PAPERS: "/call/papers",
  CALL_ORAL: "/call/oral",
  CALL_POSTER: "/call/poster",

  SPEAKERS_KEYNOTE: "/speakers/keynote",
  SPEAKERS_INVITED: "/speakers/invited",
  SPEAKERS_CHAIRS: "/speakers/chairs",
};
